export const Regex = {
  pinCode: /^[1-9][0-9]{5}$/gm,
  aadhaarNumber: /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
  phoneNumber: /^[6-9]\d{9}$/,
  healthId: /^(?=[a-zA-Z])([a-zA-Z0-9]){2,13}[a-zA-Z]$/i,
  // eslint-disable-next-line
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
};

export const CACHE_NAME = "gzero-procedure-cache";

export const isLocalHost = () => {
  return (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "[::1]" ||
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(
      window.location.hostname
    )
  );
};

export const capitalizeFirstLetter = (word) => {
  if (!word) {
    return "N/A";
  }
  const firstLetter = word.charAt(0);

  const firstLetterCap = firstLetter.toUpperCase();

  const remainingLetters = word.slice(1).toLowerCase();

  return firstLetterCap + remainingLetters;
};

export const alignPhoneNumber = (phoneNumber) => {
  if (phoneNumber?.includes(+91)) {
    const num = phoneNumber.slice(3);
    return num.slice(0, 5) + " " + num.slice(5);
  } else if (phoneNumber) {
    return phoneNumber.slice(0, 5) + " " + phoneNumber.slice(5);
  }
};

export function rippleEffect(event) {
  const parentElement = event.currentTarget;
  const containerElement = event.currentTarget.parentElement;
  const viewportOffset = parentElement.getBoundingClientRect();
  parentElement.classList.add("ripple-element");

  const circle = document.createElement("span");
  circle.classList.add("ripple-span");
  const diameter = Math.max(
    parentElement.clientWidth,
    parentElement.clientHeight
  );
  const radius = diameter / 2;

  circle.style.width = circle.style.height = `${diameter}px`;
  circle.style.left = `${
    event.clientX +
    containerElement.scrollLeft -
    parentElement.offsetLeft -
    radius
  }px`;
  circle.style.top = `${
    event.clientY + containerElement.scrollTop - viewportOffset.y - radius
  }px`;
  circle.classList.add("ripples");

  const ripple = parentElement.getElementsByClassName("ripples")[0];

  if (ripple) {
    ripple.remove();
  }
  //Add ripple element
  parentElement.appendChild(circle);
}

export function dateAndTimeConverter(timestamp, type) {
  if (!timestamp) return;

  if (type === "cardDate") {
    let dateObject = new Date(timestamp);
    const date =
      dateObject.toLocaleString("en-IN", { day: "numeric" }) +
      " " +
      dateObject.toLocaleString("en-IN", { month: "short" });
    //   +
    //   " " +
    //   dateObject.toLocaleString("en-IN", { weekday: "long" }) +
    //   " ";
    return date;
  } else {
    if (type === "firstDate") {
      let dateObject = new Date(timestamp);
      const date = dateObject
        .toLocaleString("en-IN", { day: "numeric" })
        .toUpperCase();
      return date;
    }
    if (type === "secondDate") {
      let dateObject = new Date(timestamp);
      const date =
        dateObject.toLocaleString("en-IN", { day: "numeric" }).toUpperCase() +
        " " +
        dateObject.toLocaleString("en-IN", { month: "short" }).toUpperCase() +
        " " +
        dateObject.toLocaleString("en-IN", { year: "numeric" });
      return date;
    }
  }

  if (type === "Time") {
    let dateObject = new Date(timestamp);
    const date = dateObject
      .toLocaleString("en-IN", {
        hour: "numeric" && "2-digit",
        minute: "numeric" && "2-digit",
        hour12: true
      })
      .toUpperCase();

    // + " ";
    return date;
  }
}

export const locationRange = 500; //meters
export const movePerSecond = 5; //meters
export const liveLocationUpdateTime = 5; //seconds

export function calculateDistance(location1, location2) {
  const deg2rad = (deg) => deg * (Math.PI / 180);

  if (location1 && location2) {
    const R = 6371; // Radius of the earth in kilometers
    const dLat = deg2rad(location2.latitude - location1.latitude);
    const dLon = deg2rad(location2.longitude - location1.longitude);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(location1.latitude)) *
        Math.cos(deg2rad(location2.latitude)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = Math.round(R * c * 1000); // Distance in meters

    return distance;
  } else {
    return null;
  }
}

export function getNearestLocations(
  currentLocation,
  locations,
  minDistance = 50
) {
  const { latitude, longitude } = currentLocation || {};

  if (!latitude || !longitude) return [];
  if (!locations || Object.keys(locations).length === 0) return [];

  const nearbyLocations = [];

  for (const [locationId, data] of Object.entries(locations)) {
    const loc = {
      latitude: data._geoloc?.lat,
      longitude: data._geoloc?.lng
    };

    const distance = calculateDistance({ latitude, longitude }, loc);

    if (distance !== null && distance <= minDistance) {
      nearbyLocations.push({
        locationId,
        distance,
        lat: loc.latitude,
        lng: loc.longitude
      });
    }
  }

  nearbyLocations.sort((a, b) => a.distance - b.distance);

  return nearbyLocations;
}

export const openInNewTab = (url) => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};

export const getAppsUrls = {
  admin: { title: "Admin Panel", key: "admin", url: process.env.REACT_APP_ADMIN_URL },
  public: { title: "Public App", key: "public", url: process.env.REACT_APP_PUBLIC_URL },
  employees: {
    title: "Employee App",
    key: "employees",
    url: process.env.REACT_APP_EMPLOYEES_URL
  },
  support: {
    title: "Customer support App",
    key: "support",
    url: process.env.REACT_APP_SUPPORT_URL
  }
};


export function base64ToBlob(base64, mimeType) {
  const binaryString = atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);

  for (let i = 0; i < binaryLen; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return new Blob([bytes], { type: mimeType });
}

function stripBase64Prefix(base64) {
  return base64.includes(",") ? base64.split(",")[1] : base64;
}

export function base64ToFile(base64, fileName, mimeType) {
  const data = stripBase64Prefix(base64);
  const blob = base64ToBlob(data, mimeType);
  return new File([blob], fileName, { type: mimeType });
}

export function isValidDate(dateString) {
  const regex = /^[1-9]\d{3}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) {
    return false;
  }

  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}

export function base64ToImageElement(base64String) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64String;
    img.onload = () => resolve(img);
    img.onerror = (err) => reject(err);
  });
}

export async function cropBase64Image(
  base64String,
  cropX,
  cropY,
  cropWidth,
  cropHeight
) {
  // Convert Base64 to Image Element
  const img = await new Promise((resolve, reject) => {
    const image = new Image();
    image.src = base64String;
    image.onload = () => resolve(image);
    image.onerror = (err) => reject(err);
  });

  // Create a temporary canvas to draw the cropped image
  const canvas = document.createElement("canvas");
  canvas.width = cropWidth;
  canvas.height = cropHeight;
  const ctx = canvas.getContext("2d");

  // Draw the cropped area on the canvas
  ctx.drawImage(
    img,
    cropX,
    cropY,
    cropWidth,
    cropHeight, // Source crop area
    0,
    0,
    cropWidth,
    cropHeight // Destination on canvas
  );

  // Convert the canvas back to Base64
  return canvas.toDataURL("image/png");
}
